<img *ngIf="showImage" class="sup-avatar__img" [src]="imageUrl" alt="" loading="lazy" (error)="failed = true">
<span class="sup-avatar__text" [class.sup-avatar__text--hidden]="showImage"><span class="sup-avatar__own"><ng-content></ng-content></span><span class="sup-avatar__initials">{{ initials }}</span></span>
